import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const MainWrapper = ({ className, children }) => {
    const [hasActiveLicense, setActiveLicense] = useState(null);

    const hasActiveLicenseState = useSelector(state => {
        return state.license.active.ID || false;
    });

    useEffect(() => {
        setActiveLicense(hasActiveLicenseState);
    }, [hasActiveLicenseState]);

    return (
        <div
            className={`${className} ${
                hasActiveLicense ? `dashboard-loaded` : ''
            }`}
        >
            {children}
        </div>
    );
};

MainWrapper.propTypes = {
    className: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    children: PropTypes.any.isRequired
};

export default styled(MainWrapper)`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    max-width: 480px;
    padding: 0 35px;
    background: rgb(19, 189, 239);
    background: linear-gradient(
        180deg,
        rgba(19, 189, 239, 1) 0%,
        rgba(13, 31, 161, 1) 100%
    );
    overflow: hidden;

    &.dashboard-loaded {
        padding: 0;
        background: #f5f6f8;
    }
`;
